import { atom, useAtom, useAtomValue } from 'jotai';
import { useCallback } from 'react';
import { getRewardCenterCount } from '../services/rewardcenter';
import type { RewardCenterCountRes } from '@/types/api/reward/reward-center-count.d';

/**
 * 奖励中心计数的原子状态
 */
export const rewardCountAtom = atom<number>(0);

/**
 * 使用奖励中心计数值的 Hook（只读）
 * @returns count - 当前计数
 */
export const useRewardCountValue = () => {
  return useAtomValue(rewardCountAtom);
};

/**
 * 使用奖励中心计数管理的 Hook（包含 API 调用）
 * @returns 包含计数状态和更新方法的对象
 */
export const useRewardCountManager = () => {
  const [count, setCount] = useAtom(rewardCountAtom);

  /**
   * 通过 API 更新计数
   */
  const updateClaimCount = useCallback(async () => {
    try {
      const response: RewardCenterCountRes = await getRewardCenterCount({}, false); // 非轮询请求
      setCount(response.count ?? 0);
      return response.count ?? 0;
    } catch (error) {
      console.error('Failed to update reward count:', error);
      throw error;
    }
  }, [setCount]);

  return {
    count,
    setCount,
    updateClaimCount,
  };
};
